import {STEP_TYPE_TO_ICON} from 'graphql-client/__generated/GeneratedEnumMaps';
import {PipelineStepDataKind, PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {BenchlingIconName} from 'ui-library/icons/BenchlingIcon';

export function getStepTypeIcon(stepType: PipelineStepType): BenchlingIconName | null {
  return STEP_TYPE_TO_ICON[stepType] as BenchlingIconName | null;
}

export function getStepTypeIconOrDefault(
  stepType: PipelineStepType,
  defaultIcon: BenchlingIconName
): BenchlingIconName {
  return getStepTypeIcon(stepType) ?? defaultIcon;
}

export const STEP_DATA_KIND_TO_ICON: Record<PipelineStepDataKind, BenchlingIconName> = {
  [PipelineStepDataKind.DATASET]: 'table',
  [PipelineStepDataKind.CHART]: 'analyze',
  [PipelineStepDataKind.FILE]: 'paperclip',
};

export function getIconForStepDataKind(kind: PipelineStepDataKind): BenchlingIconName {
  return STEP_DATA_KIND_TO_ICON[kind];
}
